import {Marshal} from "../../fstn/marshal";
import {Avatar, IconButton, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Paper} from "@mui/material";
import {Cloud, Delete, Edit, Panorama, ThumbUp, TouchApp} from "@mui/icons-material";

interface Props {
    dragging: boolean
    index: number
    onDelete: (index: number) => any
    onShowDetails: (index: number) => any
    marshal: Marshal
}
export default function MarshalLine({dragging, index, onDelete, onShowDetails, marshal}: Props) {
    const handleDeleteClick = () => onDelete(index);
    const handleEditClick = () => onShowDetails(index);
    const parameters = Object.keys(marshal.parameters).map(parameter => {
        const marshalData = marshal.parameters[parameter];

        return `${parameter}: ${marshalData.marshal}`
    }).join(", ");
    const icons = [
        {actions: ["CreateSprite"], icon: <Avatar><Cloud/></Avatar>},
        {actions: ["ShowStill"], icon: <Avatar><Panorama/></Avatar>},
        {actions: ["AddOption", "AddTouchGesture"], icon: <Avatar><TouchApp/></Avatar>}
    ];
    const icon = icons.find(candidate => candidate.actions.includes(marshal.action))?.icon || <Avatar><ThumbUp/></Avatar>;

    return (
        <Paper elevation={dragging ? 3 : 0}>
            <ListItem>
                <ListItemAvatar>{icon}</ListItemAvatar>
                <ListItemText primary={marshal.action} secondary={parameters}/>
                <ListItemIcon><IconButton onClick={handleEditClick} size="large"><Edit/></IconButton></ListItemIcon>
                <ListItemIcon><IconButton onClick={handleDeleteClick} size="large"><Delete/></IconButton></ListItemIcon>
            </ListItem>
        </Paper>
    );
}